import {useMutation} from '@tanstack/react-query';

import {useApiClient} from '@/hooks';

import {stepUpApi} from '../api';

import type {SendStepUpCodePayload} from '@sollapay/types';

export function useSendStepUpCodeMutation() {
  const client = useApiClient();

  return useMutation({
    mutationFn: (payload: SendStepUpCodePayload) => stepUpApi.sendCode(client, payload)
  });
}
